import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  columnsContainer: {
    display: 'grid',
    width: '100%',
    overflow: 'visible',
    justifyContent: 'space-between',
  },
  column: {
    display: 'flex',
    alignItems: 'center',
    padding: `${anatomy['size-12']} 0`,
    gap: anatomy['size-8'],
    flexGrow: 1,
    color: palette['grey-500'],
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    userSelect: 'none',
    backgroundColor: colors.deepBackground,
    ':not(:last-child) > span': {
      borderRight: `1px solid ${colors.tertiaryBorder}`,
    },
  },
  columnFixed: {
    position: 'sticky',
    zIndex: 1,
  },
  columnHeader: {
    flexGrow: 1,
    padding: `${anatomy['size-6']} ${anatomy['size-12']}`,
    display: 'flex',
    justifyContent: 'space-between',
  },
  actions: {
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    gap: anatomy['size-4'],
  },
  sortButton: {
    width: anatomy['size-20'],
    height: anatomy['size-20'],
    borderRadius: anatomy['size-20'],
    cursor: 'pointer',
    border: 'none',
    padding: 0,
    margin: 0,
    background: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '2px',
    color: palette['grey-300'],
    ':hover': {
      background: colors.hoverBackground,
    },
  },
  sortIconActive: {
    ':not(#__unused__) path': {
      fill: colors.accentIcon,
    },
  },
  filterButton: {
    width: anatomy['size-20'],
    height: anatomy['size-20'],
    borderRadius: anatomy.borderRadiusRound,
    border: '1px solid transparent',
    background: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    ':hover': {
      background: colors.hoverBackground,
    },
  },
  filterButtonActive: {
    borderColor: colors.accentBorder,
    ':hover': {
      borderColor: colors.accentBorder,
    },
  },
  filterActiveDot: {
    position: 'absolute',
    top: '4px',
    right: '4px',
    width: '5px',
    height: '5px',
    boxSizing: 'border-box',
    borderRadius: anatomy.borderRadiusRound,
    background: colors.accentIcon,
    border: `1px solid ${colors.deepBackground}`,
  },
  filterDropdownWrapper: {
    position: 'relative',
    display: 'flex',
  },
});
